import { render, staticRenderFns } from "./UyapConnectionInfo.vue?vue&type=template&id=38c8ab2b"
import script from "./UyapConnectionInfo.vue?vue&type=script&lang=ts"
export * from "./UyapConnectionInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports